"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAPI = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const has_1 = tslib_1.__importDefault(require("lodash/has"));
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const isPlainObject_1 = tslib_1.__importDefault(require("lodash/isPlainObject"));
const objects_1 = require("./objects");
const ensureCase = (data, caseType) => {
    if (caseType === 'camelCase')
        return (0, objects_1.convertKeysToCamelCase)(data);
    if (caseType === 'snake_case')
        return (0, objects_1.convertKeysToSnakeCase)(data);
    return data;
};
const toSuccess = (res) => {
    if ((0, isPlainObject_1.default)(res) && res.status === 'error')
        return toError(res);
    let mRes = (0, isArray_1.default)(res) ? { data: res } : Object.assign({}, res);
    delete mRes.code;
    delete mRes.status;
    let data = Object.assign(Object.assign({}, mRes), { statusCode: res.code, statusText: res.status, message: res.message || 'Request succeeded' });
    return data;
};
const toError = (error) => {
    try {
        let data = {};
        if (error.response) {
            const res = error.response;
            data = Object.assign(Object.assign({}, res), { statusCode: res.status, statusText: res.statusText || res.data.status });
            if (res.data.errors)
                data.errors = Object.entries(res.data.errors).reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: value })), {});
            data.message = res.data.message || res.message;
            data.ref = error.response;
        }
        else {
            data.statusCode = error.status;
            data.statusText = error.statusText;
            data.message = error.data.message;
            if (error.data.errors)
                data.errors = error.data.errors;
        }
        data.message = data.message || error.message;
        return data;
    }
    catch (_) {
        return error;
    }
};
const handler = (requestPromise, caseType) => {
    return new Promise((resolve) => {
        requestPromise
            .then((res) => resolve([false, ensureCase(toSuccess(res.data), caseType)]))
            .catch((error) => {
            resolve([
                ensureCase(toError(error.response || error), caseType),
                null,
            ]);
        });
    });
};
const createAPI = (config) => {
    // CONFIG
    const mConfig = Object.assign({ request: {
            convertCase: null,
        }, response: {
            convertCase: null,
        } }, config);
    // AXIOS INSTANCE
    const api = axios_1.default.create({
        baseURL: mConfig.baseURL,
    });
    // MIDDLEWARES
    let middlewares = [];
    // REQUEST MIDDLEWARE
    api.interceptors.request.use((conf) => {
        for (let middleware of middlewares) {
            conf = Object.assign({}, middleware(conf));
        }
        return conf;
    });
    return {
        instance: api,
        use(middleware) {
            middlewares.push(middleware);
            return this;
        },
        setHeaders(headers) {
            api.defaults.headers.common = Object.assign(Object.assign({}, api.defaults.headers.common), headers);
        },
        removeHeaders(...headers) {
            for (let key of headers) {
                if ((0, has_1.default)(api.defaults.headers.common, key)) {
                    delete api.defaults.headers.common[key];
                }
            }
        },
        get(endpoint, query = {}) {
            var _a, _b;
            return handler(api.get(endpoint, {
                params: ensureCase(query, (_a = config.request) === null || _a === void 0 ? void 0 : _a.convertCase),
            }), (_b = config.response) === null || _b === void 0 ? void 0 : _b.convertCase);
        },
        post(endpoint, body, query = {}) {
            var _a, _b, _c;
            return handler(api.post(endpoint, ensureCase(body, (_a = config.request) === null || _a === void 0 ? void 0 : _a.convertCase), {
                params: ensureCase(query, (_b = config.request) === null || _b === void 0 ? void 0 : _b.convertCase),
            }), (_c = config.response) === null || _c === void 0 ? void 0 : _c.convertCase);
        },
        put(endpoint, body, query = {}) {
            var _a, _b, _c;
            return handler(api.put(endpoint, ensureCase(body, (_a = config.request) === null || _a === void 0 ? void 0 : _a.convertCase), {
                params: ensureCase(query, (_b = config.request) === null || _b === void 0 ? void 0 : _b.convertCase),
            }), (_c = config.response) === null || _c === void 0 ? void 0 : _c.convertCase);
        },
        patch(endpoint, body, query = {}) {
            var _a, _b, _c;
            return handler(api.patch(endpoint, ensureCase(body, (_a = config.request) === null || _a === void 0 ? void 0 : _a.convertCase), {
                params: ensureCase(query, (_b = config.request) === null || _b === void 0 ? void 0 : _b.convertCase),
            }), (_c = config.response) === null || _c === void 0 ? void 0 : _c.convertCase);
        },
        delete(endpoint) {
            var _a;
            return handler(api.delete(endpoint), (_a = config.response) === null || _a === void 0 ? void 0 : _a.convertCase);
        },
    };
};
exports.createAPI = createAPI;
